import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { useAtom } from 'jotai';
import alertAtom from 'atom/alertAtom';

const GlobalAlert = () => {
  const [alert, setAlert] = useAtom(alertAtom);
  const alertRef = useRef<HTMLDivElement | null>(null);

  const closeAlert = () => {
    setAlert({ isOpen: false, type: '', message: '' });
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Escape' || event.key === 'Enter') {
      closeAlert();
    }
  };

  useEffect(() => {
    if (alert.isOpen && alertRef.current) {
      alertRef.current.focus();
    }
  }, [alert.isOpen]);

  if (!alert.isOpen) {
    return null;
  }

  return (
    <Alert ref={alertRef} onKeyDown={handleKeyDown} tabIndex={0}>
      <AlertWrapper>
        <Title>알림</Title>
        <Contents>{alert.message}</Contents>
        <CloseButton onClick={closeAlert}>닫기</CloseButton>
      </AlertWrapper>
    </Alert>
  );
};

export default GlobalAlert;

const Alert = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  font-family: 'Noto Sans KR', sans-serif;
  z-index: 9999;
`;

const AlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  align-items: center;
  gap: 24px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 420px;
  height: 296px;
  padding: 24px 32px;
  border-radius: 16px;
  background-color: ${color.white};
`;

const Title = styled.div`
  line-height: 20px;
  font-weight: 700;
  color: ${color.black};
`;

const Contents = styled.div`
  font-size: 14px;
  color: ${color.black08};
`;

const CloseButton = styled.button`
  width: 120px;
  height: 36px;
  border-radius: 18px;
  font-size: 13px;
  line-height: 16px;
  background-color: ${color.mobile};
  color: ${color.white};
`;
